"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentGatewayById = void 0;
const getPaymentGatewayById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("payment_methods")
        .select("*")
        .eq("id", id)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.getPaymentGatewayById = getPaymentGatewayById;
